'use strict';

var _errors = require('./errors.js');

var _case = require('./case.js');

var _case2 = _interopRequireDefault(_case);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var match = function match(value) {
  return function () {
    for (var _len = arguments.length, functionCases = Array(_len), _key = 0; _key < _len; _key++) {
      functionCases[_key] = arguments[_key];
    }

    var cases = functionCases.map(function (aCase) {
      return _case2.default.build(aCase);
    });

    var matchingCase = cases.find(function (aCase) {
      return aCase.matches(value);
    });
    if (!matchingCase) throw new _errors.MatchError();

    return matchingCase.getResultFunction()(matchingCase.binds() ? value : undefined);
  };
};

module.exports = match;